function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    if (parts.length === 2) return parts.pop().split(';').shift();
};

function setCookie(name, value, days, domain = '.futureproof.app') {
    let expires = '';

    if (days) {
        let date = new Date();

        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));

        expires = "; expires=" + date.toUTCString();
    }
    
    document.cookie = `${name}=${value}${expires}; path=/; domain=${domain}; Secure; SameSite=None`;
};

export {
    getCookie,
    setCookie
};
